import styled from 'styled-components';

import { EllipseStyled as EllipseStyledBase } from '@qality/common-components/src/atoms/Ellipse';

export const ContainerStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LatestExecutionStyled = styled.div`
  font-size: 12px;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  display: flex;
  align-items: center;
`;

export const EllipseStyled = styled(EllipseStyledBase)`
  margin-left: 4px;
  margin-right: 4px;
`;

export const StatusTextStyled = styled.div`
  color: var(--ds-text, var(--ds-fb-text));
  white-space: nowrap;
`;

export const NoExecutionTextWrapperStyled = styled.div`
  margin-bottom: 4px;
`;
